import React, { useEffect, useState } from "react";

// ASSETS
import Illustration from "assets/icons/Deco corner homepage white.svg";
import Image from "assets/img/FirePhoto.jpg";
import CivicDialogue1 from "assets/img/dialog civic/CivicDialogue1.jpg";
import CivicDialogue2 from "assets/img/dialog civic/CivicDialogue2.jpg";
import CivicDialogue3 from "assets/img/dialog civic/CivicDialogue3.jpg";
import CivicDialogue4 from "assets/img/dialog civic/CivicDialogue4.jpg";
import CivicDialogue5 from "assets/img/dialog civic/CivicDialogue5.jpg";
import CivicDialogue6 from "assets/img/dialog civic/CivicDialogue6.jpg";
import CivicDialogue7 from "assets/img/dialog civic/CivicDialogue7.jpg";
import CivicDialogue11 from "assets/img/dialog civic/CivicDialogue11.jpg";
import CivicDialogue9 from "assets/img/dialog civic/CivicDialogue9.jpg";
import CivicDialogue10 from "assets/img/dialog civic/CivicDialogue10.jpg";

import news2 from "assets/img/news2.jpg";

// STYLES
import {
  Body,
  FileWrapper,
  ImageCard,
  ImagesRow,
  ImagesSection,
  LeftSideWrapper,
  Line,
  ParentContainer,
  RightSideWrapper,
  Section,
  SectionIllustration,
  SmallImageCard,
  TabsWrapper,
  Title,
} from "./VolunteerSectionStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { DownloadFileType } from "components/Atoms/DownloadFileAtom/DownloadFileAtomModel";
import { COLORS } from "constants/variables";
import { IProps } from "./VolunteerSectionModel";
import { HeaderTabTypes } from "components/HeaderTab/HeaderTabModel";
import { selectLanguage } from "slices/LanguageSlice/languageSlice";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import DownloadFileAtom from "components/Atoms/DownloadFileAtom/DownloadFileAtom";
import useWindowWidth from "hooks/useWindowWidth";
import HeaderTab from "components/HeaderTab/HeaderTab";
import civicDialogueService from "services/civicDialogueService";
import { uploadBaseUrl } from "services/base";
import StrapiTreeText from "components/Atoms/StrapiTreeText/StrapiTreeText";

const VolunteerSection: React.FC<IProps> = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const language = useSelector(selectLanguage);

  // STATE CONSTANTS
  const windowWidth = useWindowWidth();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [firstDocument, setFirstDocument] = useState<any>();
  const [secondDocument, setSecondDocument] = useState<any>();
  const [data, setData] = useState<any>();
  const tabs = [
    {
      id: 0,
      tabTitle: t("view.volunteerSection.tabs.smurd"),
      content: <StrapiTreeText text={data?.smurd} color={COLORS.Cultured} />,
    },
    {
      id: 1,
      tabTitle: t("view.volunteerSection.tabs.salvamont"),
      content: (
        <StrapiTreeText text={data?.salvamont} color={COLORS.Cultured} />
      ),
    },
  ];

  const smurdImages = [
    CivicDialogue2,
    CivicDialogue1,
    CivicDialogue3,
    CivicDialogue4,
    CivicDialogue5,
  ];
  const salvamontImages = [
    CivicDialogue6,
    CivicDialogue7,
    CivicDialogue11,
    CivicDialogue9,
    CivicDialogue10,
  ];

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    civicDialogueService
      .getVoluntaryInfo()
      .then((response) => {
        // console.log("getVoluntaryInfo resp", response);
        setData(response?.data?.attributes);
      })
      .catch((err) => {
        console.log("getVolunteerDocuments error", err);
      });
    civicDialogueService
      .getVolunteerDocuments(12)
      .then((response) => {
        setFirstDocument(response?.data?.attributes);
      })
      .catch((err) => {
        console.log("getVolunteerDocuments error", err);
      });
    civicDialogueService
      .getVolunteerDocuments(11)
      .then((response) => {
        setSecondDocument(response?.data?.attributes);
      })
      .catch((err) => {
        console.log("getVolunteerDocuments error", err);
      });
  }, [language]);

  // EVENT HANDLERS

  const handleTabSelect = (selectedTabId: number) => {
    setSelectedTab(selectedTabId);
  };

  const getImageSet = () => {
    return selectedTab === 0 ? smurdImages : salvamontImages;
  };

  return (
    <ParentContainer>
      {windowWidth > 1227 && <SectionIllustration src={Illustration} alt="" />}
      <Title>
        <CustomText
          text={t("view.volunteerSection.title")}
          type={TextType.H2}
          color={COLORS.Yellow}
        />
        <CustomText
          text={t("view.volunteerSection.subtitle")}
          type={TextType.H3}
          color={COLORS.Background}
        />
      </Title>
      <TabsWrapper>
        <HeaderTab
          tabs={tabs}
          onTabSelect={handleTabSelect}
          type={HeaderTabTypes.WhiteTheme}
        />
      </TabsWrapper>
      <Section>
        <LeftSideWrapper>
          <Body>{tabs[selectedTab].content}</Body>
        </LeftSideWrapper>
        {windowWidth < 1227 && <Line />}
        <RightSideWrapper>
          <ImagesSection>
            <ImageCard src={getImageSet()[0]} alt="" />
            <ImagesRow>
              {getImageSet()
                .slice(1)
                .map((imgSrc, index) => (
                  <SmallImageCard key={index} src={imgSrc} alt="" />
                ))}
            </ImagesRow>
          </ImagesSection>
          {/* <FileWrapper>
            <DownloadFileAtom
              type={DownloadFileType.Dialogue}
              institution={t("view.volunteerSection.body.documents")}
              description={t("view.volunteerSection.body.download")}
              pdfUrl={`${uploadBaseUrl}${
                selectedTab === 0
                  ? firstDocument?.attached_document?.data?.attributes?.url ||
                    ""
                  : secondDocument?.attached_document?.data?.attributes?.url ||
                    ""
              }`}
            />
          </FileWrapper> */}
        </RightSideWrapper>
      </Section>
    </ParentContainer>
  );
};

export default VolunteerSection;
